import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useAuth0, getDefaultAuth0Config } from '@architeia/auth'

export const useAuthStore = defineStore('auth', () => {
  const auth0Config = getDefaultAuth0Config()
  const {
    isAuthenticated,
    isLoading,
    user,
    error,
    login,
    logout,
    getAccessToken,
    handleRedirectCallback,
    initialize
  } = useAuth0(auth0Config)

  void initialize()

  const displayName = computed(() => {
    if (!user.value) return null
    return user.value.displayName || user.value.name || user.value.email || 'Member'
  })

  /** After login or register, land on the in-app home. */
  const postAuthPath = '/home'

  async function loginReturningToHome() {
    await login({ redirectPath: postAuthPath })
  }

  async function registerReturningToHome() {
    await login({ redirectPath: postAuthPath, screenHint: 'signup' })
  }

  return {
    isAuthenticated,
    isLoading,
    user,
    error,
    displayName,
    postAuthPath,
    loginReturningToHome,
    registerReturningToHome,
    login,
    logout,
    getAccessToken,
    handleRedirectCallback,
    initialize
  }
})
